import { createFeature, createReducer, on } from "@ngrx/store";
import { IntentTypes } from "../../../shared/enums";
import { RegistrationState } from "../registration.models";
import { registrationActions } from "./actions";

export const initialRegistrationState: RegistrationState = {
  isLoading: false,
  intent: IntentTypes.empty,
  otpSent: false,
  otpMatch: false,
  registered: false,
  cardNumber: "",
  data: {
    termsAccepted: false,
    marketingConsent: false,
    canvasser: {
      username: "",
    },
    email: {
      address: "",
    },
    identificationDocument: {
      country: "",
      idNumber: "",
      type: "",
    },
    mobile: {
      number: "",
      otp: "",
    },
    personalInfo: {
      name: "",
      lastname: "",
      dateOfBirth: "",
    },
  },
};

const registrationFeature = createFeature({
  name: "registration",
  reducer: createReducer(
    initialRegistrationState,

    //store canvasser details
    on(registrationActions.canvasserLogin, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        canvasser: { username: event.username },
      },
    })),

    //terms
    on(registrationActions.termsAccepted, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        termsAccepted: true,
        marketingConsent: true,
      },
    })),

    //lookup
    on(registrationActions.requestLookup, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestLookupSuccess, (state, event) => ({
      ...state,
      intent: event.intent!,
      data: {
        ...state.data,
        identificationDocument: {
          type: event.lookupData?.idType!,
          country: event.lookupData?.idCountry!,
          idNumber: event.lookupData?.number!,
        },
        personalInfo: {
          ...state.data.personalInfo,
          dateOfBirth: event.lookupData?.dateOfBirth!,
        },
      },
      isLoading: false,
    })),
    on(registrationActions.requestLookupFailed, (state, event) => ({
      ...state,
      intent: IntentTypes.empty,
      isLoading: false,
    })),

    //store personal details
    on(registrationActions.requestStorePersonalDetails, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        personalInfo: {
          ...state.data.personalInfo,
          name: event.personalInfo?.name!,
          lastname: event.personalInfo?.lastname!,
        },
        email: event.email!,
        mobile: event.mobile!,
      },
      isLoading: false,
    })),

    //otp request
    on(registrationActions.requestOTPViaMsisdn, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestOTPViaMsisdnSuccess, (state, event) => ({
      ...state,
      otpSent: true,
      isLoading: false,
    })),
    on(registrationActions.requestOTPViaMsisdnFailed, (state, event) => ({
      ...state,
      otpSent: false,
      isLoading: false,
    })),

    //otp validation
    on(registrationActions.requestOTPValidation, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestOTPValidationSuccess, (state, event) => ({
      ...state,
      otpMatch: true,
      data: {
        ...state.data,
        mobile: {
          ...state.data.mobile,
          otp: event.otp,
        },
      },
      isLoading: false,
    })),
    on(registrationActions.requestOTPValidationFailed, (state, event) => ({
      ...state,
      otpMatch: false,
      isLoading: false,
    })),

    //registration
    on(registrationActions.requestRegistration, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestRegistrationSuccess, (state, event) => ({
      ...state,
      registered: true,
      cardNumber: event.cardNumber!,
      isLoading: false,
    })),
    on(registrationActions.requestRegistrationFailed, (state, event) => ({
      ...state,
      registered: false,
      cardNumber: "",
      isLoading: false,
    })),

    //reset types
    on(registrationActions.requestFullReset, (state) => ({
      ...initialRegistrationState,
    })),
    on(registrationActions.requestPartialReset, (state) => ({
      ...initialRegistrationState,
      data: {
        ...initialRegistrationState.data,
        canvasser: state.data.canvasser,
      },
    })),
    on(registrationActions.requestResetIntent, (state) => ({
      ...state,
      intent: IntentTypes.empty,
    })),
    on(registrationActions.requestResetOtpSent, (state) => ({
      ...state,
      otpSent: false,
    })),
    on(registrationActions.requestResetOtpMatch, (state) => ({
      ...state,
      otpMatch: false,
    })),
    on(registrationActions.requestResetTerms, (state) => ({
      ...state,
      data: {
        ...state.data,
        termsAccepted: false,
        marketingConsent: false,
      },
    }))
  ),
});

export const { name: registrationFeatureKey, reducer: registrationReducer } =
  registrationFeature;
